import { render } from "./Brands.vue?vue&type=template&id=3abe1780&scoped=true&ts=true"
import script from "./Brands.ts?vue&type=script&lang=ts&external"
export * from "./Brands.ts?vue&type=script&lang=ts&external"

import "./Brands.vue?vue&type=style&index=0&id=3abe1780&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abe1780"]])

export default __exports__